import React from 'react';

export interface RadioGroupContextProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  disabled?: boolean;
  name?: string;
}

const RadioGroupContext = React.createContext<RadioGroupContextProps | null>(null);

export const RadioGroupContextProvider = RadioGroupContext.Provider;
export const useRadioGroup = () => React.useContext(RadioGroupContext);
